<div class="body_bg">
  <div class="main_wrapper">
    <frontend-verify-header></frontend-verify-header>
    <frontend-side-bar></frontend-side-bar>
    <div class="main_content">
      <div class="profile_verification_main">
        <div class="row">
          <div class="col-lg-4">
            <div class="complete_profile">
              <p>
                Complete your <br />
                artist’s profile
              </p>
              <div class="progress_bars">
                <div class="progres"><img src="assets/images/Bar.png" /></div>
                <div class="progress_percent">80%</div>
              </div>
              <div class="artist_lists">
                <ul>
                  <li>
                    <h4>Upload podcasts</h4>
                    <span> <img src="assets/images/upload.svg" /></span>
                  </li>
                  <li>
                    <h4>Upload episodes</h4>
                    <span> <img src="assets/images/upload.svg" /></span>
                  </li>
                  <li>
                    <h4>Tax Identity Information</h4>
                    <span> <img src="assets/images/upload.svg" /></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="promote">
              <h4 class="">The right way to promote your podcast</h4>
              <p class="profile_para_text">
                Here’s a guide to keep your audience engaged online
              </p>
              <a href="#">Learn more</a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="profile_not_verified">
              <h4 class="">
                Complete your bank <br />
                details
              </h4>
              <p class="profile_para_text">
                Add your bank account to which you wish to receive the deposits
              </p>
              <a href="#">Add my bank information</a>
            </div>
          </div>
        </div>
      </div>
      <div class="your_stats">
        <div class="stats_heading_bar">
          <div class="stats_heading">Your stats</div>
          <frontend-custom-select
            class="custom"
            [(selectedValue)]="selectedValue"
            [selectOptions]="selectOptions"
            placeholder="Select your country "
            [searchable]="false"
          >
          </frontend-custom-select>
        </div>
        <div class="stats_count">
          <div class="row">
            <div class="col-lg-6">
              <div class="stats_graph">
                <div class="stats_box_title">
                  <img src="assets/images/Collaborative.svg" />
                  <h6 class="">Audience</h6>
                </div>
                <div class="stats_box_counting">
                  <h3 class="">274</h3>
                </div>
                <div class="stats_graph_box">
                  <img src="assets/images/Graph.png" />
                  <p class="graph_box_days">
                    <span>Day 1</span> <span>Day 5</span> <span>Day 10</span>
                    <span>Day 15</span> <span>Day 20</span> <span>Day 25</span>
                    <span>Day 30</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="stats_count_boxes">
                <div class="row">
                  <div class="col-lg-4 col-sm-6 col-6">
                    <div class="stats_small_box">
                      <div class="stats_box_title">
                        <img src="assets/images/Streams.svg" />
                        <h6 class="">Streams</h6>
                      </div>
                      <div class="stats_box_counting">
                        <h3 class="">574</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-sm-6 col-6">
                    <div class="stats_small_box">
                      <div class="stats_box_title">
                        <img src="assets/images/static/like.png" />
                        <h6 class="">Likes</h6>
                      </div>
                      <div class="stats_box_counting">
                        <h3 class="">20</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-sm-6 col-6">
                    <div class="stats_small_box">
                      <div class="stats_box_title">
                        <img src="assets/images/Followers.png" />
                        <h6 class="">Followers</h6>
                      </div>
                      <div class="stats_box_counting">
                        <h3 class="">20</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-sm-6 col-6">
                    <div class="stats_small_box">
                      <div class="stats_box_title">
                        <img src="assets/images/Revenue.svg" />
                        <h6 class="">Revenue</h6>
                      </div>
                      <div class="stats_box_counting">
                        <h3 class="">£369.24</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-sm-6 col-6">
                    <div class="stats_small_box">
                      <div class="stats_box_title">
                        <img src="assets/images/View.svg" />
                        <h6 class="">Visits</h6>
                      </div>
                      <div class="stats_box_counting">
                        <h3 class="">20</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-sm-6 col-6">
                    <div class="stats_small_box">
                      <div class="stats_box_title">
                        <img src="assets/images/Actions.svg" />
                        <h6 class="">Downloads</h6>
                      </div>
                      <div class="stats_box_counting">
                        <h3 class="">20</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="top_list">
        <div class="row">
          <div class="col-lg-6">
            <div class="your_stats">
              <div class="stats_heading_bar1">
                <div class="stats_heading">Your top podcasts</div>
                <div class="reproductions">Reproductions</div>
              </div>
              <div class="top_songs">
                <ul>
                  <li>
                    <div class="artist_detials">
                      <div class="artist_img">
                        <img src="assets/images/static/Photo6.png" />
                      </div>
                      <div class="artist_content">
                        <h1>Podcast name goes here</h1>
                        <span>Creator name</span>
                      </div>
                    </div>
                    <div class="artist_count">
                      <p>83</p>
                    </div>
                  </li>

                  <li>
                    <div class="artist_detials">
                      <div class="artist_img">
                        <img src="assets/images/static/Photo7.png" />
                      </div>
                      <div class="artist_content">
                        <h1>Podcast name goes here</h1>
                        <span>Creator name</span>
                      </div>
                    </div>
                    <div class="artist_count">
                      <p>83</p>
                    </div>
                  </li>

                  <li>
                    <div class="artist_detials">
                      <div class="artist_img">
                        <img src="assets/images/static/Photo8.png" />
                      </div>
                      <div class="artist_content">
                        <h1>Podcast name goes here</h1>
                        <span>Creator name</span>
                      </div>
                    </div>
                    <div class="artist_count">
                      <p>83</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="your_stats">
              <div class="stats_heading_bar1">
                <div class="stats_heading">Your top episodes</div>
                <div class="reproductions">Reproductions</div>
              </div>

              <div class="top_songs">
                <ul>
                  <li>
                    <div class="artist_detials">
                      <div class="artist_img">
                        <img src="assets/images/static/Photo9.png" />
                      </div>
                      <div class="artist_content">
                        <h1>Episode name goes here</h1>
                        <span>Podcast title</span>
                      </div>
                    </div>
                    <div class="artist_count">
                      <p>83</p>
                    </div>
                  </li>

                  <li>
                    <div class="artist_detials">
                      <div class="artist_img">
                        <img src="assets/images/static/Photo10.png" />
                      </div>
                      <div class="artist_content">
                        <h1>Episode name goes here</h1>
                        <span>Podcast title</span>
                      </div>
                    </div>
                    <div class="artist_count">
                      <p>83</p>
                    </div>
                  </li>

                  <li>
                    <div class="artist_detials">
                      <div class="artist_img">
                        <img src="assets/images/static/Photo11.png" />
                      </div>
                      <div class="artist_content">
                        <h1>Episode name goes here</h1>
                        <span>Podcast title</span>
                      </div>
                    </div>
                    <div class="artist_count">
                      <p>83</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar_mob">
      <div class="bottom_bar">
        <ul class="aside_list">
          <li class="active_bottom_li">
            <div class="lsit_item">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  class="btmsvg_icon"
                  d="M8 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H8C9.10457 22 10 21.1046 10 20V4C10 2.89543 9.10457 2 8 2ZM4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H8C10.2091 24 12 22.2091 12 20V4C12 1.79086 10.2091 0 8 0H4ZM16 4V5C16 6.10457 16.8954 7 18 7L20 7C21.1046 7 22 6.10457 22 5V4C22 2.89543 21.1046 2 20 2L18 2C16.8954 2 16 2.89543 16 4ZM14 5C14 7.20914 15.7909 9 18 9H20C22.2091 9 24 7.20914 24 5V4C24 1.79086 22.2091 0 20 0H18C15.7909 0 14 1.79086 14 4V5ZM16 20V15C16 13.8954 16.8954 13 18 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H18C16.8954 22 16 21.1046 16 20ZM18 24C15.7909 24 14 22.2091 14 20V15C14 12.7909 15.7909 11 18 11H20C22.2091 11 24 12.7909 24 15V20C24 22.2091 22.2091 24 20 24H18Z"
                  fill="$neutral_20"
                />
              </svg>
            </div>
          </li>
          <li class=" ">
            <div class="lsit_item">
              <svg
                width="20"
                height="25"
                viewBox="0 0 20 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  class="btmsvg_icon"
                  d="M12 2H8C6.89543 2 6 2.89543 6 4V13C6 14.1046 6.89543 15 8 15H12C13.1046 15 14 14.1046 14 13V4C14 2.89543 13.1046 2 12 2ZM8 0C5.79086 0 4 1.79086 4 4V13C4 15.2091 5.79086 17 8 17H12C14.2091 17 16 15.2091 16 13V4C16 1.79086 14.2091 0 12 0H8ZM0.999841 13C0.447557 13 -0.00671493 13.45 0.0614878 13.998C0.552704 17.9453 3.91954 21 7.99984 21H9V24C9 24.5523 9.44771 25 10 25C10.5523 25 11 24.5523 11 24V21H11.9998C16.0801 21 19.447 17.9453 19.9382 13.998C20.0064 13.45 19.5521 13 18.9998 13C18.4476 13 18.0086 13.4511 17.9176 13.9958C17.4432 16.8356 14.9743 19 11.9998 19H7.99984C5.02538 19 2.55645 16.8356 2.0821 13.9958C1.99111 13.4511 1.55213 13 0.999841 13Z"
                  fill="$neutral_20"
                />
              </svg>
            </div>
          </li>
          <li class="">
            <div class="lsit_item">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  class="btmsvg_icon"
                  d="M8.65116 24H15.3488C21.4102 24 24 21.4102 24 15.3488V8.65116C24 2.58977 21.4102 0 15.3488 0H8.65116C2.58977 0 0 2.58977 0 8.65116V15.3488C0 21.4102 2.58977 24 8.65116 24ZM1.67442 8.65116C1.67442 3.50512 3.50512 1.67442 8.65116 1.67442H15.3488C20.4949 1.67442 22.3256 3.50512 22.3256 8.65116V15.3488C22.3256 20.4949 20.4949 22.3256 15.3488 22.3256H8.65116C3.50512 22.3256 1.67442 20.4949 1.67442 15.3488V8.65116ZM9.90317 18.8651H14.1098L14.1234 18.865H18.3403C18.8091 18.865 19.1775 18.4854 19.1775 18.0277V14.2212C19.1775 13.0603 18.2287 12.1114 17.0677 12.1114H14.9581V7.24456C14.9581 6.08363 14.0093 5.13477 12.8484 5.13477H11.1516C9.99068 5.13477 9.04186 6.08363 9.04186 7.24456V10.2028H6.93155C5.77062 10.2028 4.8218 11.1517 4.8218 12.3126V18.028C4.8218 18.4856 5.20134 18.8652 5.65901 18.8652H9.88968L9.90317 18.8651ZM10.7274 17.1906H13.2724V12.9486C13.2724 12.9024 13.2763 12.8569 13.2837 12.8125V7.24456C13.2837 7.01014 13.094 6.80919 12.8484 6.80919H11.1516C10.9172 6.80919 10.7163 6.99898 10.7163 7.24456V10.9082C10.7233 10.9512 10.7269 10.9953 10.7269 11.04V17.1906H10.7274ZM17.5031 17.1905H14.9581V13.7858H17.0677C17.3133 13.7858 17.5031 13.9868 17.5031 14.2212V17.1905ZM9.04186 11.8884V17.1908H6.49622V12.3237C6.49622 12.0781 6.69713 11.8884 6.93155 11.8884H9.04186Z"
                  fill="$neutral_20"
                />
              </svg>
            </div>
          </li>
          <li class="">
            <div class="lsit_item">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  class="btmsvg_icon"
                  d="M1.67442 7.51391C1.67442 5.41626 2.19973 3.99637 3.10362 3.09499C4.00752 2.19361 5.43138 1.66976 7.53488 1.66976H16.4651C18.5686 1.66976 19.9925 2.19361 20.8964 3.09499C21.8003 3.99637 22.3256 5.41626 22.3256 7.51391V13.0798C22.3256 15.1774 21.8003 16.5973 20.8964 17.4987C19.9925 18.4001 18.5686 18.9239 16.4651 18.9239H15.907C15.2953 18.9239 14.7154 19.216 14.3474 19.6989L14.3442 19.7032L12.6698 21.9295C12.4363 22.2399 12.1856 22.3302 12 22.3302C11.8144 22.3302 11.5637 22.2399 11.3302 21.9295L9.65877 19.7071C9.46571 19.4451 9.19594 19.2595 8.95743 19.1416C8.71587 19.0222 8.40872 18.9239 8.09302 18.9239H7.53488C5.31713 18.9239 3.92803 18.633 3.06293 17.8782C2.22549 17.1475 1.67442 15.7907 1.67442 13.0798V7.51391ZM7.53488 0C5.17327 0 3.24829 0.589325 1.91963 1.91429C0.590969 3.23925 0 5.15888 0 7.51391V13.0798C0 15.9347 0.565209 17.9175 1.96032 19.1348C3.32778 20.328 5.28752 20.5937 7.53488 20.5937H8.08738C8.09041 20.5941 8.09999 20.5956 8.11616 20.5999C8.14362 20.6073 8.17784 20.6199 8.21374 20.6376C8.24972 20.6554 8.27902 20.6743 8.2992 20.6899C8.30739 20.6963 8.31242 20.7008 8.3149 20.7032L8.31628 20.705L9.9907 22.9314C10.494 23.6005 11.2145 24 12 24C12.7855 24 13.506 23.6005 14.0093 22.9314L15.6805 20.7093L15.6817 20.7077C15.7379 20.635 15.8271 20.5937 15.907 20.5937H16.4651C18.8267 20.5937 20.7517 20.0044 22.0804 18.6794C23.409 17.3544 24 15.4348 24 13.0798V7.51391C24 5.15888 23.409 3.23925 22.0804 1.91429C20.7517 0.589325 18.8267 0 16.4651 0H7.53488ZM16.4612 9.74026C15.8447 9.74026 15.3449 10.2386 15.3449 10.8534C15.3449 11.4682 15.8447 11.9666 16.4612 11.9666H16.4712C17.0877 11.9666 17.5875 11.4682 17.5875 10.8534C17.5875 10.2386 17.0877 9.74026 16.4712 9.74026H16.4612ZM10.8787 10.8534C10.8787 10.2386 11.3785 9.74026 11.995 9.74026H12.005C12.6215 9.74026 13.1213 10.2386 13.1213 10.8534C13.1213 11.4682 12.6215 11.9666 12.005 11.9666H11.995C11.3785 11.9666 10.8787 11.4682 10.8787 10.8534ZM7.52875 9.74026C6.91225 9.74026 6.41247 10.2386 6.41247 10.8534C6.41247 11.4682 6.91225 11.9666 7.52875 11.9666H7.53878C8.15528 11.9666 8.65506 11.4682 8.65506 10.8534C8.65506 10.2386 8.15528 9.74026 7.53878 9.74026H7.52875Z"
                  fill="$neutral_20"
                />
              </svg>
            </div>
          </li>
          <li class="">
            <div class="lsit_item">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.05917 2.05919C3.54881 0.569533 5.77789 0 8.65116 0H15.3488C18.2221 0 20.4512 0.569533 21.9408 2.05919C23.4305 3.54885 24 5.77796 24 8.65126V15.349C24 17.5265 23.6746 19.3276 22.8726 20.7215C22.0508 22.1498 20.7789 23.064 19.082 23.5444L19.0769 23.5458C18.0412 23.856 16.817 24 15.349 24H8.65132C7.18497 24 5.96183 23.8563 4.92689 23.5469L4.918 23.5444C3.22105 23.064 1.94917 22.1498 1.12736 20.7215C0.325371 19.3276 0 17.5265 0 15.349V8.65126C0 5.77796 0.569527 3.54885 2.05917 2.05919ZM17.8922 22.1138C17.5862 21.0345 16.7952 20.0532 15.6728 19.3685C14.7431 18.8068 13.6026 18.4535 12.3713 18.394C12.2488 18.3882 12.125 18.3853 12 18.3853C11.8781 18.3853 11.7573 18.3881 11.6377 18.3935C10.3885 18.4525 9.23226 18.814 8.29437 19.3887C7.18939 20.0724 6.41083 21.045 6.10784 22.1138C6.84419 22.2587 7.68088 22.3256 8.65132 22.3256H15.349C16.3193 22.3256 17.1559 22.2587 17.8922 22.1138ZM19.4958 21.6175C18.8567 19.3797 16.8414 17.6818 14.3495 17.017C13.6069 16.8179 12.817 16.7106 12.0002 16.7106C11.4323 16.7106 10.8773 16.7627 10.3421 16.8615C7.53678 17.3773 5.2015 19.176 4.50425 21.6175C3.63733 21.2211 3.01755 20.6492 2.57869 19.8864C1.98533 18.8551 1.67442 17.3911 1.67442 15.349V8.65126C1.67442 5.94311 2.22117 4.2652 3.24316 3.2432C4.26515 2.2212 5.94304 1.67444 8.65116 1.67444H15.3488C18.057 1.67444 19.7349 2.2212 20.7568 3.2432C21.7788 4.2652 22.3256 5.94311 22.3256 8.65126V15.349C22.3256 17.3911 22.0147 18.8551 21.4213 19.8864C20.9825 20.6492 20.3627 21.2211 19.4958 21.6175ZM8.86957 10.8438C8.85068 10.7036 8.84093 10.5604 8.84093 10.415C8.84093 10.3963 8.84109 10.3776 8.84141 10.359C8.87149 8.64332 10.2774 7.25598 12 7.25598C13.7414 7.25598 15.1591 8.67369 15.1591 10.4151C15.1591 12.0015 13.9975 13.3135 12.4856 13.548C12.3273 13.5725 12.1651 13.5852 12 13.5852C11.8321 13.5852 11.6672 13.5721 11.5064 13.5468C10.1369 13.3308 9.05643 12.2303 8.86957 10.8438ZM7.16747 10.3175C7.21927 7.69002 9.35997 5.58146 12 5.58146C14.6726 5.58146 16.8335 7.74238 16.8335 10.415C16.8335 12.961 14.8709 15.0571 12.3683 15.2459C12.2468 15.2551 12.1239 15.2598 12 15.2598C11.8735 15.2598 11.7481 15.2549 11.624 15.2453C9.12506 15.0528 7.16651 12.9584 7.16651 10.415C7.16651 10.3824 7.16683 10.3499 7.16747 10.3175Z"
                  fill="$neutral_20"
                />
              </svg>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
